__webpack_require__.p = "/github-discussions-blog/";